// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__header[data-v-2f0a7852]{background:#1a243e;display:flex}.dialog_header[data-v-2f0a7852]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex:1;color:#fff}.option-buttons[data-v-2f0a7852]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
